import { render, staticRenderFns } from "./ApplyPC.vue?vue&type=template&id=454e675e&scoped=true"
import script from "./ApplyPC.vue?vue&type=script&lang=js"
export * from "./ApplyPC.vue?vue&type=script&lang=js"
import style0 from "./ApplyPC.vue?vue&type=style&index=0&id=454e675e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454e675e",
  null
  
)

export default component.exports